import React from 'react';
import { Home, Waves, MapPin, ChefHat, Car, Wifi, Check } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Amenities() {
  const { t } = useLanguage();
  const icons = [Home, Waves, MapPin, ChefHat, Car, Wifi];

  return (
    <section id="amenities" className="py-24 md:py-32 bg-[#faf6ef]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm tracking-[0.3em] uppercase text-[#b8945e] font-medium mb-4">{t.amenities.eyebrow}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-stone-900">{t.amenities.title}</h2>
          <div className="w-20 h-px bg-[#b8945e] mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-20">
          {t.amenities.list.map((item, i) => {
            const Icon = icons[i];
            return (
              <div key={i} className="group bg-white rounded-2xl p-6 text-center shadow-sm hover:shadow-xl transition-all hover:-translate-y-1 border border-stone-100">
                <div className="text-stone-300 text-2xl font-serif mb-3">0{i + 1}</div>
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-[#b8945e]/10 flex items-center justify-center group-hover:bg-[#b8945e] transition-colors">
                  <Icon size={22} className="text-[#b8945e] group-hover:text-white transition-colors" />
                </div>
                <p className="text-sm font-semibold text-stone-800 leading-tight">{item}</p>
              </div>
            );
          })}
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg">
          <h3 className="font-serif text-3xl text-stone-900 mb-10 text-center">{t.amenities.featuresTitle}</h3>
          <div className="grid md:grid-cols-3 gap-10">
            <FeatureList title={t.amenities.kitchenTitle} items={t.amenities.kitchen} />
            <FeatureList title={t.amenities.bedroomTitle} items={t.amenities.bedroom} />
            <FeatureList title={t.amenities.miscTitle} items={t.amenities.misc} />
          </div>
        </div>
      </div>
    </section>
  );
}

function FeatureList({ title, items }) {
  return (
    <div>
      <h4 className="text-lg font-semibold text-[#b8945e] mb-5 pb-3 border-b border-stone-200">{title}</h4>
      <ul className="space-y-2.5">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-2 text-stone-700 text-sm">
            <Check size={16} className="text-[#b8945e] mt-0.5 flex-shrink-0" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
